export const googleCalendarConstants = {
    LOGIN_REQUEST: 'GOOGLE_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'GOOGLE_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'GOOGLE_LOGIN_FAILURE',

    REDIRECT_REQUEST: "EVENT_REDIRECT_REQUEST",
    REDIRECT_SUCCESS: "EVENT_REDIRECT_SUCCESS",
    REDIRECT_FAILURE: "EVENT_REDIRECT_FAILURE",

    CREATE_REQUEST: "EVENT_CREATE_REQUEST",
    CREATE_SUCCESS: "EVENT_CREATE_SUCCESS",
    CREATE_FAILURE: "EVENT_CREATE_FAILURE",

    GET_REQUEST: "EVENT_GET_REQUEST",
    GET_SUCCESS: "EVENT_GET_SUCCESS",
    GET_FAILURE: "EVENT_GET_FAILURE",
    
    GET_ALL_REQUEST: "EVENT_GET_ALL_REQUEST",
    GET_ALL_SUCCESS: "EVENT_GET_ALL_SUCCESS",
    GET_ALL_FAILURE: "EVENT_GET_ALL_FAILURE",

    UPDATE_REQUEST: "EVENT_UPDATE_REQUEST",
    UPDATE_SUCCESS: "EVENT_UPDATE_SUCCESS",
    UPDATE_FAILURE: "EVENT_UPDATE_FAILURE",

    DELETE_REQUEST: "EVENT_DELETE_REQUEST",
    DELETE_SUCCESS: "EVENT_DELETE_SUCCESS",
    DELETE_FAILURE: "EVENT_DELETE_FAILURE",

    LOGOUT_REQUEST: "GOOGLE_LOGOUT_REQUEST",
    LOGOUT_SUCCESS: "GOOGLE_LOGOUT_SUCCESS",
    LOGOUT_FAILURE: "GOOGLE_LOGOUT_FAILURE",
}